import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content"]

  connect() {
    // Ensure the first tab is active by default
    this.showTab(this.tabTargets[0]?.dataset.tab || "overview")
  }

  switch(event) {
    event.preventDefault()
    const tabId = event.currentTarget.dataset.tab
    this.showTab(tabId)
  }

  showTab(tabId) {
    // Update tab buttons
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === tabId
      
      if (isActive) {
        tab.classList.add("active")
        // Remove inactive styles
        tab.classList.remove("border-transparent", "text-theme-muted", "hover:text-theme-primary", "hover:border-theme-border")
        // Add active styles - use theme-aware classes or fallback to k3c colors
        if (tab.classList.contains("text-theme-muted")) {
          tab.classList.add("border-theme-accent", "text-theme-accent")
        } else {
          tab.classList.add("border-k3c-coral", "text-k3c-coral")
        }
      } else {
        tab.classList.remove("active")
        // Remove active styles
        tab.classList.remove("border-theme-accent", "text-theme-accent", "border-k3c-coral", "text-k3c-coral")
        // Add inactive styles - use theme-aware classes or fallback to gray
        if (tab.classList.contains("hover:text-theme-primary")) {
          tab.classList.add("border-transparent", "text-theme-muted", "hover:text-theme-primary", "hover:border-theme-border")
        } else {
          tab.classList.add("border-transparent", "text-gray-300")
        }
      }
    })

    // Update content panels
    this.contentTargets.forEach(content => {
      const isActive = content.dataset.tab === tabId
      
      if (isActive) {
        content.classList.remove("hidden")
        content.classList.add("tab-content")
        // Add smooth transition
        content.style.opacity = "0"
        content.style.transform = "translateY(10px)"
        setTimeout(() => {
          content.style.transition = "opacity 0.3s ease, transform 0.3s ease"
          content.style.opacity = "1"
          content.style.transform = "translateY(0)"
        }, 10)
      } else {
        content.classList.add("hidden")
        content.classList.remove("tab-content")
        // Reset styles
        content.style.transition = ""
        content.style.opacity = ""
        content.style.transform = ""
      }
    })
  }
} 